import { __decorate } from "tslib";
import { mixins } from 'vue-class-component';
import { Component } from 'vue-property-decorator';
import Avatar from '@/components/avatar/Index.vue';
import PagePreviewWithFormMixin from '@/helpers/vue_mixins/v2/PagePreviewWithFormMixin';
import WebviewBackgroundOverlay from '@/components/v2/preview/WebviewBackgroundOverlay.vue';
import WebviewHeader from '@/components/v2/preview/WebviewHeader.vue';
import { DIY } from '@/helpers/constants/Store';
import { Getter } from 'vuex-class';
import { textTruncate } from '@/helpers/text_truncate';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import TheClosePreviewTemplate from '@/components/v2/diy/TheClosePreviewTemplate';
let CategoryPagePreview = class CategoryPagePreview extends mixins(PagePreviewWithFormMixin, ViewportSizeMixin) {
    constructor() {
        super(...arguments);
        this.webviewHeader = 'Shop Now';
    }
    truncatedDescription(description) {
        return textTruncate(description || 'N/A', 130);
    }
};
__decorate([
    Getter('categoryDetails', { namespace: DIY })
], CategoryPagePreview.prototype, "categoryDetails", void 0);
CategoryPagePreview = __decorate([
    Component({
        components: {
            Avatar,
            WebviewBackgroundOverlay,
            WebviewHeader,
            TheClosePreviewTemplate,
        },
    })
], CategoryPagePreview);
export default CategoryPagePreview;
